/*
 * @Author: lzy
 * @Date: 2021-07-06 18:31:29
 * @LastEditTime: 2022-01-18 18:32:34
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\website\all\websiteAllCtrl.js
 * @Description: 网站渠道全部
 */

'use strict';
angular.module('websiteAllModule', []).controller('websiteAllCtrl', [
    '$scope',
    '$state',
    '$q',
    '$filter',
    '$window',
    'editingCenterService',
    'editcenterRightsService',
    'trsHttpService',
    'editingMediatype',
    'initSingleSelecet',
    'globleParamsSet',
    'trsspliceString',
    'modalDialog',
    'messagePublishService',
    'newMediaService',
    'websiteConst',
    'sensitiveWordCheckService',
    'trsPrintService',
    'editRepetitiveBtnService',
    'websiteService',
    'storageListenerService',
    function (
        $scope,
        $state,
        $q,
        $filter,
        $window,
        editingCenterService,
        editcenterRightsService,
        trsHttpService,
        editingMediatype,
        initSingleSelecet,
        globleParamsSet,
        trsspliceString,
        modalDialog,
        messagePublishService,
        newMediaService,
        websiteConst,
        sensitiveWordCheckService,
        trsPrintService,
        editRepetitiveBtnService,
        websiteService,
        storageListenerService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始换状态
         *
         * @return {[type]}   [return description]
         */
        function initStatus() {
            $scope.data = {
                items: [],
                selectedArray: [],
                trench: websiteConst.listenStroageKey,
                file: [],
                printResult: [],
                editPath: websiteService.getEditandPreviewPath().edit,
            };
            $scope.status = {
                hasphotoflag: false, // 用于判断是否是人为设置图集模式
                hasphoto: false, // 判断是否是图集模式
                draftType: websiteConst.draftTypeToNum, // 根据稿件类型转换为对应的数字,与后端返回的稿件类型ID对应
                detailMethodname: websiteConst.detailMethodname, // 根据后端返回的稿件类型ID转换为请求详情的接口
                plat: '' // 记录当前选中的稿件的platform, 同时判断有没有选中多个流程的稿件，控制按钮的显示，多个流程的话只显示没有权限的按钮
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.getPageSize(),
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.params = {
                serviceid: 'mlf_website',
                methodname: 'queryAll',
                SiteId: $state.params.siteid,
                ChannelId: $state.params.channelid,
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                IsCurrentChnl: true,
            };
            $scope.rights = {};
        }

        /**
         * [initData description] 初始换数据
         * @return {[type]}   [return description]
         */
        function initData() {
            listenStorage();
            initDropList();
            if (!angular.isDefined($state.params.siteid)) {
                return;
            } // 如果没有站点，不进行初始化请求
            if (!angular.isDefined($state.params.channelid)) {
                return;
            } // 如果没有栏目id，不进行初始化请求
            refreshList();
            getRights('web.all').then(function (rights) {
                $scope.status.isCanMove = rights['web.all.gaojianpaixu'];
            });
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenWebsite(function () {
                $scope.status.isESSearch = false;
                requestData();
                storageListenerService.removeListener('website');
            }, $scope);
        }


        /**
         * [initDropList description] 初始化下拉框
         * @return  {[type]}  [return description]
         */
        function initDropList() {
            $scope.data.docTypeArray = initSingleSelecet.websiteDocType();
            $scope.data.selectedDocType = angular.copy($scope.data.docTypeArray[0]);
        }

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function (key, value) {
            $scope.page.CURRPAGE = '1';
            // 下拉框判断
            switch (key) {
                case 'timeType':
                    $scope.params.OperTimeStart = $scope.data.fromdate;
                    $scope.params.OperTimeEnd = $scope.data.untildate;
                    break;
                // case 'IsCurrentChnl':
                case 'IsOnlyMine':
                    $scope.params[key] = !value;
                    break;
                default:
                    $scope.params[key] = value;
            }
            requestData();
        };

        /**
         * [refreshList description]刷新列表, 监听es请求
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe('refresh', function (event, data) {
                if (angular.isObject(data)) {
                    $scope.status.isEsSearch = true; // es检索状态
                    $scope.esParams = data;
                } else {
                    $scope.status.isEsSearch = false;
                }
                $scope.page.CURRPAGE = 1;
                requestData();
            }, $scope);
        }

        $scope.requestData = function() {
            requestData().then(function() {
                initFixedPos();
            });
        };
        $scope.pageChanged = requestData;

        /**
         * [requestData description] 请求列表数据
         * @return {[type]}   [return description]
         */
        function requestData() {
            var defer = $q.defer();
            if (!angular.isDefined($state.params.channelid)) { // 如果没有栏目id，不进行初始化请求 
                defer.reject();
            } else {
                var params = Object.assign($scope.params, {
                    CurrPage: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE
                });
                if ($scope.status.isEsSearch) {
                    params = dealEsParams();
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.status.hasphoto = !$scope.status.hasphotoflag && $scope.params.DocType === '2';
                    $scope.data.items = data.DATA;
                    $scope.page = data.PAGER;
                    if ($scope.data.items.length) {
                        editingCenterService.queryVerifyDoc($scope.data.items).then(function(data) {
                            $scope.data.filterReviseItem = $scope.data.items.filter((item) => item.APPSTATUSNAME !== '待修订' && item.verifyDocIsCanOper);
                        });
                    }
                    $scope.data.selectedArray = [];
                    requestListImg(data.DATA);
                    newMediaService.getReviseInfo(data.DATA);
                    $scope.data.selectedArray = [];
                    $scope.status.plat = '';
                    defer.resolve();
                }, function() {
                    defer.reject();
                });
            }
            
            return defer.promise;
        }

        /**
         * [dealEsParams description] 组装es请求参数
         * @return {[type]}   [return description]
         */
        function dealEsParams() {
            return {
                methodname: 'queryDoc',
                serviceid: 'mlf_hybasesearch',
                MediaType: editingMediatype.website,
                'searchParams': JSON.stringify({
                    PAGESIZE: $scope.page.PAGESIZE, // 分页
                    PAGEINDEX: $scope.page.CURRPAGE, // 页码
                    searchFields: [ // 检索条件
                        {
                            'searchField': '',
                            'keywords': $scope.data.keyWords || ''
                        },
                        {
                            'searchField': 'docType',
                            'keywords': $scope.data.selectedDocType.value
                        },
                        {
                            'searchField': 'timeType',
                            'keywords': angular.isDefined($scope.data.untildate) ? $scope.data.untildate + ',' + $scope.data.fromdate : ''
                        },
                        {
                            'searchField': 'isOnlyMine',
                            'keywords': $scope.params.IsOnlyMine || ''
                        },
                        {
                            'searchField': 'isOnlyCurChannel',
                            'keywords': true
                        },
                        {
                            'searchField': 'siteid',
                            'keywords': $state.params.siteid
                        },
                        {
                            'searchField': 'channelid',
                            'keywords': $state.params.channelid
                        },
                        {
                            'searchField': '_sort',
                            'keywords': 'time'
                        }
                    ]
                })
            };
        }

        /**
         * [getRights description]获取权限。在选中稿件时要获取对应流程的权限
         * @param {[type]} type   [type description]
         * @return {[type]}   [return description]
         */
        function getRights(type) {
            var defer = $q.defer();
            if ($state.params.channelid) {
                editcenterRightsService.initWebsiteListBtn(type, $state.params.channelid).then(function (rights) {
                    defer.resolve(rights);
                });
            } else {
                defer.resolve({});
            }
            return defer.promise;
        }

        /**
         * [getPlatRights description] 获取稿件所对应流程的权限
         * @param {[type]} item   [item description]
         * @return {[type]}   [return description]
         */
        function getPlatRights(item) {
            if (item.PLATFORM > 0 && !$scope.rights[item.PLATFORM]) {
                var types = ['web.daibian', 'web.daishen', 'web.yiqianfa'];
                getRights(types[item.PLATFORM - 1]).then(function (rights) {
                    $scope.rights[item.PLATFORM] = {};
                    for (var key in rights) {
                        var rightKey = key.split('.');
                        $scope.rights[item.PLATFORM][rightKey[rightKey.length - 1]] = rights[key];
                    }
                });
            }
        }

        /**
         * [requestListImg description]查询图示列表
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function requestListImg(items) {
            if (items.length) {
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'queryAllImgLogo',
                    metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    angular.forEach(items, function (value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
            }
        }

        // 全选
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.filterReviseItem.length ? [] : [].concat($scope.data.filterReviseItem);
            isMultiple();
            if ($scope.data.selectedArray.length && $scope.status.plat !== 'multiple') {
                getPlatRights($scope.data.selectedArray[0]);
            }
            checkHasNoFixed();
        };

        // 单选
        $scope.selectDoc = function (item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
                getPlatRights(item);
                if ($scope.status.plat !== '' && $scope.status.plat !== item.PLATFORM) {
                    $scope.status.plat = 'multiple';
                } else {
                    $scope.status.plat = item.PLATFORM;
                }
            } else {
                $scope.data.selectedArray.splice(index, 1);
                isMultiple();
            }
            checkHasNoFixed();
        };

        /**
         * [isMultiple description] 判断选中的稿件有没有多流程的
         * @return {[type]}   [return description]
         */
        function isMultiple() {
            $scope.status.plat = '';
            var length = $scope.data.selectedArray.length;
            if (!length) {
                return;
            }
            for (var i = 0; i < length; i++) {
                if ($scope.status.plat !== '' && $scope.data.selectedArray[i].PLATFORM !== $scope.status.plat) {
                    $scope.status.plat = 'multiple';
                    return;
                } else {
                    $scope.status.plat = $scope.data.selectedArray[i].PLATFORM;
                }
            }
        }


        /**
         * [showVersionTime description]展示流程版本与操作日志
         * @param  {[object]} item [description] 稿件信息
         * @return {[type]}        [description]
         */
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };


        // h5拖拽结束, 用于手动拖拽排序
        $scope.getIndex = function (index) {
            $scope.moveIndex = index;
        };

        $scope.dropCallback = function (index, item) {
            if (!$scope.status.isCanMove) {
                modalDialog.alertType('登录用户没有权限对稿件进行排序', '', 'info', 'confrim');
                return;
            }
            var trueIndex;
            var params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'sortPositionMetaDatasForAll',
                ChannelId: $state.params.channelid,
                FromChnlDocId: item.CHNLDOCID,
            };
            if ($scope.moveIndex < index) {
                trueIndex = index - 1;
                params.Position = 0;
            } else {
                trueIndex = index;
                params.Position = 1;
            }
            if (item.GDORDER && (item.GDORDER > 0 || $scope.data.items[trueIndex].GDORDER > 0)) {
                modalDialog.alertType('操作失败', '所操作的稿件存在已经固定位置的稿件,无法移动位置', 'warning', true);
                return;
            }
            if (item.GDORDER && (item.DOCORDERPRI > 0 || $scope.data.items[trueIndex].DOCORDERPRI > 0)) {
                modalDialog.alertType('操作失败', '所操作的稿件存在已经置顶的稿件,无法移动位置', 'warning', true);
                return;
            }
            params.ToChnlDocId = $scope.data.items[trueIndex].CHNLDOCID;
            modalDialog.alertType('位置调整', '确定调整位置么？', 'info', true, function () {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    modalDialog.alertType('位置调整成功！', '', 'success');
                    requestData();
                });
            }, function () {
                requestData();
            });
            return item;
        };

        /**
         * [jumpToPage description] 跳转到指定页面
         * @return  {[type]}  [return description]
         */
        $scope.jumpToPage = function () {
            if ($scope.page.CURRPAGE > $scope.page.PAGECOUNT) {
                $scope.page.CURRPAGE = $scope.page.PAGECOUNT;
            }
            requestData();
        };

        /**
         * [trial description] 送审方法
         * @return  {[type]}  [return description]
         */
        $scope.trial = function () {
            $scope.status.isESSearch = false;
            $scope.loadingPromise = newMediaService.trial($scope, websiteConst.trial);
        };

        /**
         * [directSign description] 直接签发
         * @return  {[type]}  [return description]
         */
        $scope.directSign = function () {
            $scope.status.isESSearch = false;
            let queryTitleContent = true;
            let queryShenKanQianFa = trsspliceString.spliceString($scope.data.selectedArray, 'CLIENTEXAMINE', ',');
            if (!queryShenKanQianFa.includes('0')) {
                queryTitleContent = false;
            }
            sensitiveWordCheckService.SensitiveWordsAndCareful($scope.data.selectedArray, '', editingMediatype.website, queryTitleContent).then(
                function () {
                    signed();
                },
                function () {
                    signed();
                }
            );
        };

        /**
         * [signed description]签发方法
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function signed() {
            var method = [websiteConst.daibianSign, websiteConst.daishenSign];
            $scope.loadingPromise = newMediaService.sign($scope, method[$scope.status.plat - 1], signCallBack);
        }

        /**
         * [multitermTiimeSigned description]定时签发
         *
         * @return  {[type]}  [return description]
         */
        $scope.timeSigned = function () {
            $scope.status.isESSearch = false;
            sensitiveWordCheckService.SensitiveWordsAndCarefulTiming($scope.data.selectedArray).then(
                function () {
                    // 
                },
                function () {
                    timeSigned();
                }
            );
        };

        /**
         * [timeSigned description]定时签发方法
         * @return  {[type]}  [return description]
         */
        function timeSigned() {
            var method = [websiteConst.daibianTimeSign, websiteConst.daishenTimeSign];
            $scope.loadingPromise = newMediaService.timeSign($scope, method[$scope.status.plat - 1], signCallBack);
        }

        /**
         * [signCallBack description] 签发回调
         * @param   {[object]}  params  [params description]
         * @param   {[array]}  array   [array description]
         * @return  {[type]}          [return description]
         */
        function signCallBack(params, array) {
            var ChnlDocIds = [];
            var ObjectIds = [];
            var MetaDataIds = [];
            for (var i = 0; i < array.length; i++) {
                ChnlDocIds.push(array[i].DOC.CHNLDOCID);
                ObjectIds.push(array[i].DOC.CHNLDOCID);
                MetaDataIds.push(array[i].DOC.METADATAID);
            }
            params.ChnlDocIds = ChnlDocIds.join(',');
            params.ObjectIds = ObjectIds.join(',');
            params.MetaDataIds = MetaDataIds.join(',');
        }

        /**
         * [rejectionDraft description] 撤稿方法
         * @return  {[type]}  [return description]
         */
        $scope.rejection = function () {
            $scope.status.isESSearch = false;
            $scope.loadingPromise = newMediaService.rejection($scope, websiteConst.rejection);
        };

        /**
         * [waste description] 废稿方法
         * @return  {[type]}  [return description]
         */
        $scope.waste = function () {
            $scope.status.isESSearch = false;
            newMediaService.delete($scope, websiteConst.delete);
        };

        /**
         * [revoke description] 取消签发
         * @return  {[type]}  [return description]
         */
        $scope.revoke = function () {
            $scope.status.isESSearch = false;
            $scope.loadingPromise = newMediaService.retraction($scope, websiteConst.withdrawrejection);
        };

        /**
         * [collect description] 稿件收藏
         * @return  {[type]}  [return description]
         */
        $scope.collect = function () {
            if (checkSecondReview()) {
                modalDialog.alertType('无法进行操作', '包含二次送审流程中的稿件,不能收藏', 'error', 'confirm');
                return;
            }
            if (editcenterRightsService.judgeCanBeCollected($scope.data.selectedArray)) {
                modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', 'confirm', '');
                return;
            }
            $scope.status.isESSearch = false;
            let params = {
                1: websiteConst.collectDB,
                2: websiteConst.collectDS,
                3: websiteConst.collectYQF
            };
            $scope.loadingPromise = newMediaService.collect($scope, params[$scope.data.selectedArray[0].PLATFORM]);
        };

        /**
        * [draftImport description]导入文档
        * @return {[type]} [description]
        */
        $scope.draftImport = function () {
            $scope.status.isESSearch = false;
            $scope.loadingPromise = editingCenterService.draftImport(
                'mlf_extmyrelease',
                'websiteImportDoc',
                $state.params.channelid,
                $scope.data.file,
                function () {
                    requestData();
                },
                function () {
                    delete $scope.data.file;
                }
            );
        };

        /**
         * [follow description] 稿件关注
         * @return  {[type]}  [return description]
         */
        $scope.follow = function () {
            $scope.status.isESSearch = false;
            if (checkOneType($scope.status.draftType.subject) !== $scope.data.selectedArray.length) {
                modalDialog.alertType('只能关注专题稿', '', 'error', false);
                return;
            }
            var params = {
                serviceid: 'mlf_tag',
                methodname: 'focusonSpecial',
                MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function () {
                modalDialog.alertType('关注成功', '', 'success', false, function () {
                    requestData();
                });
            });
        };

        /**
         * [tenantManuShare 租户间共享]
         * @return {[type]} [description]
         */
        $scope.tenantManuShare = function () {
            if (checkOneType($scope.status.draftType.subject)) {
                modalDialog.alertType('无法进行共享', '所选稿件中包含专题稿', 'info');
                return;
            }
            let params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'pluralisticShare',
                dataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
            };
            editingCenterService.tenantShareManu(params).then(function (data) {
                requestData();
            });
        };

        /**
         * [revise description]修订
         * @return {[type]} [description]
         */
        $scope.revise = function () {
            let reviseParams = {
                1: websiteConst.reviseDB,
                2: websiteConst.reviseDS
            };
            let transferData = {
                SiteId: $state.params.siteid,
                DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                UserId: '',
            };
            transferData = angular.extend(transferData, reviseParams[$scope.data.selectedArray[0].PLATFORM]);
            newMediaService.revise($scope, transferData);
        };

        /**
        * [printBtn description]打印
        * @return  {[type]}  [return description]
        */
        $scope.print = function () {
            if (!selectDraftTip()) {
                return;
            }
            if (checkOneType($scope.status.draftType.subject) || checkOneType($scope.status.draftType.video)) {
                modalDialog.alertType('所选稿件中有专题稿或视频稿，无法打印', '', 'error', 'confirm');
                return;
            }
            $scope.status.isESSearch = false;
            angular.forEach($scope.data.selectedArray, function (value, key) {
                requestPrintData(value);
            });
        };

        /**
         * [exportDraft description]导出稿件
         * @return  {[type]}  [return description]
         */
        $scope.export = function () {
            $scope.status.isESSearch = false;
            if (!selectDraftTip()) {
                return;
            }
            let news = checkOneType($scope.status.draftType.news);
            let atlas = checkOneType($scope.status.draftType.atlas);
            if ((news + atlas) !== $scope.data.selectedArray.length) {
                modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
                return;
            }
            let params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportWordFile',
                MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                function (data) {
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                    $scope.data.selectedArray = [];
                },
                function (data) {
                    if (data.REPORTS[0].ISSUCCESS.toString() === 'true') {
                        window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                        $scope.data.selectedArray = [];
                    }
                }
            );
        };

        /**
         * [outSending description] 邮件外发触发
         * @return  {[type]}        [return description]
         */
        $scope.outSending = function () {
            if (!selectDraftTip()) {
                return;
            }
            if (checkOneType($scope.status.draftType.video)) {
                modalDialog.alertType('所选稿件中含有视频稿，无法外发', '', 'error', 'confirm');
                return;
            }
            $scope.status.isESSearch = false;
            editingCenterService.outSending('', function (result) {
                outSendingDraft(result.selectItems);
            });
        };

        /**
        * [outSendingDraft description] 邮件外发执行
        * @param   {[array]}  items  [items description] 选中的稿件集合
        * @return  {[type]}          [return description]
        */
        function outSendingDraft(items) {
            let userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            let draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
            let outSending = {
                1: websiteConst.outSendDB,
                2: websiteConst.outSendDS,
                3: websiteConst.outSendYQF
            };
            let params = {
                Emails: userids,
                MetaDataIds: draftids,
            };
            params = angular.extend(params, outSending[$scope.data.selectedArray[0].PLATFORM]);
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                function () {
                    modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
                        requestData();
                    });
                },
                function () {
                    $scope.data.selectedArray = [];
                }
            );
        }

        /**
        * [requestPrintData description]description：打印请求详情
        * @param   {[type]}  item     [item description]
        * @param   {[type]}  version  [version description]
        * @return  {[type]}           [return description]
        */
        function requestPrintData(item, version) {
            let params = {
                serviceid: 'mlf_website',
                methodname: $scope.status.detailMethodname[item.DOCTYPEID],
                MetaDataId: item.METADATAID,
            };
            let printLimitNum = 27; // 打印每行规定字数
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / printLimitNum);
                $scope.data.printResult.push(data);
                if ($scope.data.printResult.length === $scope.data.selectedArray.length) {
                    trsPrintService.trsWebPrintDocument($scope.data.printResult);
                    $scope.data.printResult = [];
                }
            });
        }

        /**
         * [checkSecondReview description] 判断所选稿件中是否带有二次审核的稿件
         * @return {[type]} [description]
         */
        function checkSecondReview() {
            let secondReview = $filter('pick')($scope.data.selectedArray, (elm) => elm.ISSECONDREVIEW && elm.ISSECONDREVIEW * 1 === 1);
            return secondReview.length; 
        }

        /**
         * [checkOneType description]所选稿件是否是统一类型
         * @param   {[number]}  typeId  [typeId description] 稿件类型对应的ID
         * @return  {[type]}            [return description]
         */
        function checkOneType(typeId) {
            let filterArray = $filter('filterBy')($scope.data.selectedArray, ['DOCTYPEID'], typeId);
            return filterArray.length;
        }

        /**
        * [selectDraftTip description] 选择稿件提示
        * @return {[boolean]} [description]
        */
        function selectDraftTip() {
            if ($scope.data.selectedArray.length === 0) {
                modalDialog.alertType('请先选择稿件', '', 'warning', 'confirm');
            }
            return $scope.data.selectedArray.length;
        }

        /** 多元分发
         * [distribution description]
         * @return {[type]} [description]
         */
        $scope.distribution = function() {
            if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')){
                modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                return;
            }
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
            if (temp.length < 1) {
                var methods = ['webDaiBianDistribute', 'webDaiShenTransmitDoc', 'webYiQianFaDistribute'];
                editingCenterService.distribution($scope.data.selectedArray, '2', $scope.data.selectedArray[0].DOCTYPEID, methods[$scope.status.plat - 1], function() {
                    $scope.data.selectedArray = [];
                    requestData();
                });
            } else {
                modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、图集、视频', 'warning', 'confirm', function() {});
            }
        };

        /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
         * [examDistributionType description]
         * @param  {[type]} elm [description]
         * @return {[type]}     [description]
         */
        $scope.examDistributionType = function(elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID !== '1' && elm.DOCTYPEID !== '2' && elm.DOCTYPEID !== '7';
            }
        };

        /**
         * [multipleSign description] 多签
         *
         * @return {[type]}   [return description]
         */
        $scope.multipleSign = function() {
            editRepetitiveBtnService.multipleChannelSign($scope.data.selectedArray, 3).then(
                () => {
                    requestData();
                },
                () => {
                    requestData();
                }
            );
        };

        /**
         * [rank description]排序
         * @return {[type]} [description] null
         */
        $scope.rank = function() {
            $scope.status.isESSearch = false;
            var isSingleDraft = examSelectedArray('排序');
            if (isSingleDraft === true) {
                var channelid = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLID', ',');
                editingCenterService.rank(
                    channelid,
                    $scope.data.selectedArray,
                    $scope.fixedPos,
                    {
                        serviceid: 'mlf_websiteoper',
                        methodname: 'sortSetUpMetaDatas',
                        isAll: true
                    },
                    function(data) {
                        modalDialog.alertType('排序成功', '', 'success', false);
                        requestData();
                    }
                );
            }
        };

        /**
         * [examSelectedArray description]
         *
         * @param {[type]} name   [name description]
         *
         * @return {[type]}   [return description]
         */
        function examSelectedArray(name) {
            var flag = true;
            if ($scope.data.selectedArray.length > 1) {
                flag = false;
                modalDialog.alertType(name + '失败', name + '操作只能选择单篇稿件', 'error');
            }
            if ($scope.data.selectedArray[0].GDORDER > 0) {
                flag = false;
                modalDialog.alertType(name + '失败', name + '操作不包含已固定稿件', 'error');
            }
            return flag;
        }

        /**
         * [stick description]置顶
         * @return {[type]} [description] null
         */
        $scope.stick = function() {
            $scope.status.isESSearch = false;
            if ($scope.data.selectedArray.length !== 1) {
                modalDialog.alertType('请选择单篇稿件', '', 'warning', false);
                return;
            }
            if ($scope.data.selectedArray[0].GDORDER > 0) {
                modalDialog.alertType('该文档已固定位置,无法进行置顶操作', '', 'warning', false);
                return;
            }
            var topFlag = $scope.data.selectedArray[0].DOCORDERPRI === '0' ? 2 : 0;
            modalDialog.confirmModal(topFlag === 2 ? '置顶？' : '取消置顶？', topFlag === 2 ? '确认要置顶该稿件？' : '确定要取消置顶该稿件？', function() {
                var params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'setTopDocument',
                    ChannelId: parseInt($scope.data.selectedArray[0].CHNLID),
                    DocumentId: $scope.data.selectedArray[0].METADATAID,
                    TargetDocumentId: $scope.data.items[0].DOCORDERPRI === '0' ? '0' : $scope.data.items[0].METADATAID,
                    TopFlag: topFlag,
                    Position: 1,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                    requestData();
                }, function() {
                    requestData();
                });
            });
        };

        /**
         * [fixed description] 稿件固定位置
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.fixed = function () {
            if ($scope.status.showFixPosition === false) {
                modalDialog.confirmModal('取消固定位置', '是否确认取消固定位置', function() {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'fixedPositionOfMeta',
                        ChannelId: $state.params.channelid,
                        ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                        IsFixedPos: false
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                        modalDialog.alertType('操作成功', '', 'success', false);
                        requestData();
                    });
                });
                return;
            }
            if ($scope.data.selectedArray.length > 50) {
                modalDialog.alertType('您已超出允许选择固定的稿件数量,只能固定50条', '', 'info', false);
                return;
            }
            var params = {
                serviceid: 'mlf_website',
                methodname: 'querySignedDocForFixed',
                ChannelId: $state.params.channelid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                editingCenterService.fixPositionModel({
                    selectedArray: angular.copy($scope.data.selectedArray),
                    items: angular.copy(data.DATA),
                }, 'website').then(
                    (res) => {
                        requestData();
                    },
                    function() {
                        requestData();
                    }
                );
            });
        };

        /**
         * [selectDoc description]
         * @return  {[type]}        [return description]
         */
        function checkHasNoFixed() {
            for (let i = 0; i < $scope.data.selectedArray.length;i++) {
                if ($scope.data.selectedArray[i].GDORDER == '0' || !$scope.data.selectedArray[i].GDORDER) {
                    $scope.status.showFixPosition = true;
                    break;
                } else {
                    $scope.status.showFixPosition = false;
                }
            }
        }

        /**
         * [initFixedPos description]初始化已固定的稿件
         *
         * @return {[type]}   [return description]
         */
        function initFixedPos() {
            $scope.fixedPos = []; // 已经固定位置的稿件的位置集合
            angular.forEach($scope.data.items, function(item, index) {
                if (item.GDORDER > 0) {
                    $scope.fixedPos.push(Number(item.GDORDER));
                }
            });
        }

        /**
         * [routerToEdit description]编辑前请求解锁
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.routerToEdit = function (item) {
            $scope.status.isESSearch = false;
            let editUrl = packageRouterParams(item);
            $window.open(editUrl);
        };

        /**
         * [packageRouterParams description] 组装路由参数
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function packageRouterParams(item) {
            let editPath = $scope.data.editPath[item.DOCTYPEID];
            let editParams = {
                wzchannelid: $state.params.channelid,
                wzchnldocid: item.CHNLDOCID,
                wzmetadataid: item.METADATAID,
                wzsiteid: $state.params.siteid,
                wzplatform: 0,
            };
            return $state.href(editPath, editParams);
        }
    }
]);
